<!-- 饼图的配置 -->
<template>
  <div>
    <el-collapse accordion>
      <template v-if="main.activeOption.spreadSheetType === SPREAD_SHEET_TYPE.BASIC">
        <el-collapse-item title="样式设置" name="1">
          <el-form-item labelAlign="left" labelWidth="90" label="主题设置">
            <el-color-picker :predefine="predefineColors" v-model="main.activeOption.themeColor"></el-color-picker>
          </el-form-item>
          <el-form-item labelAlign="left" labelWidth="90" label="展示模式"
                        tip="行头的展示方式，grid：平铺网格结构， tree： 树状结构">
            <el-radio-group v-model="main.activeOption.config.hierarchyType" size="small">
              <el-radio-button label="grid">网格结构</el-radio-button>
              <el-radio-button label="tree">树状结构</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item labelAlign="left" labelWidth="120" label="禁用高亮">
            <el-switch v-model="main.activeOption.config.frozenTable" size="small"/>
          </el-form-item>
          <el-form-item labelAlign="left" labelWidth="120" label="显示行序号">
            <el-switch v-model="main.activeOption.config.showSeriesNumber" size="small"/>
          </el-form-item>
          <el-form-item labelAlign="left" labelWidth="90" label="空白填充" tip="空单元格的填充内容">
            <el-input v-model="main.activeOption.config.placeholder" size="small"/>
          </el-form-item>
          <el-form-item labelAlign="left" labelWidth="90" label="角头文本" tip="自定义角头文本 （仅在树状模式有效）">
            <el-input v-model="main.activeOption.config.cornerText" size="small"/>
          </el-form-item>
          <el-form-item labelAlign="left" labelWidth="90" label="提示框" tip="是否展示tooltip">
            <el-switch v-model="main.activeOption.config.tooltip.showTooltip" size="small"/>
          </el-form-item>
        </el-collapse-item>
      </template>
      <el-collapse-item v-else title="样式设置" name="1">
        <el-form-item labelAlign="left" labelWidth="90" label="主题设置">
          <el-color-picker :predefine="predefineColors" v-model="main.activeOption.themeColor"></el-color-picker>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="100" label="显示序号">
          <el-switch v-model="main.activeOption.config.showSeriesNumber" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="120" label="禁用高亮">
          <el-switch v-model="main.activeOption.config.frozenTable" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="开启排行">
          <el-switch v-model="main.activeOption.config.rankFlag" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="空白填充" tip="空单元格的填充内容">
          <el-input v-model="main.activeOption.config.placeholder" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="提示框" tip="是否展示tooltip">
          <el-switch v-model="main.activeOption.config.tooltip.showTooltip" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="冻结行" tip="冻结行的数量，从顶部开始计数">
          <el-input-number v-model="main.activeOption.config.frozenRowCount" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="冻结列" tip="冻结列的数量，从左侧开始计数">
          <el-input-number v-model="main.activeOption.config.frozenColCount" size="small"/>
        </el-form-item>
      </el-collapse-item>

      <el-collapse-item title="背景设置" name="237">
        <el-form-item label="透明背景色">
          <el-switch v-model="main.activeOption.isTransparent" size="small"></el-switch>
        </el-form-item>
      </el-collapse-item>

      <el-collapse-item title="行样式" name="23">
        <el-form-item labelAlign="left" labelWidth="90" label="隐藏排序" tip="是否隐藏排序按钮，默认展示">
          <el-switch v-model="main.activeOption.config.hideOrder" size="small"/>
        </el-form-item>
        <template v-if="main.activeOption?.totals?.row">
          <el-form-item labelAlign="left" labelWidth="90" label="行总计">
            <el-switch v-model="main.activeOption.totals.row.showGrandTotals" size="small"></el-switch>
          </el-form-item>
        </template>
        <el-form-item labelAlign="left" labelWidth="90" label="行宽">
          <el-input-number v-model="main.activeOption.config.style.rowCfg.width" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="行高">
          <el-input-number v-model="main.activeOption.config.style.rowCfg.height" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="字体大小">
          <el-input-number v-model="main.activeOption.theme.rowCell.text.fontSize" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="字体颜色">
          <el-color-picker :predefine="predefineColors"
                           v-model="main.activeOption.theme.rowCell.text.fill"></el-color-picker>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="背景色">
          <el-color-picker :predefine="predefineColors"
                           v-model="main.activeOption.theme.rowCell.cell.backgroundColor"></el-color-picker>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="对齐方式">
          <el-radio-group v-model="main.activeOption.theme.rowCell.text.textAlign" size="small">
            <el-radio-button label="left">左对齐</el-radio-button>
            <el-radio-button label="right">右对齐</el-radio-button>
            <el-radio-button label="center">居中对齐</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item title="列样式" name="233">
        <template v-if="main.activeOption?.totals?.col">
          <el-form-item labelAlign="left" labelWidth="90" label="列总计">
            <el-switch v-model="main.activeOption.totals.col.showGrandTotals" size="small"></el-switch>
          </el-form-item>
        </template>
        <el-form-item labelAlign="left" labelWidth="90" label="列宽">
          <el-input-number v-model="main.activeOption.config.style.colCfg.width" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="列高">
          <el-input-number v-model="main.activeOption.config.style.colCfg.height" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="字体大小">
          <el-input-number v-model="main.activeOption.theme.colCell.text.fontSize" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="字体颜色">
          <el-color-picker :predefine="predefineColors"
                           v-model="main.activeOption.theme.colCell.text.fill"></el-color-picker>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="背景色">
          <el-color-picker :predefine="predefineColors"
                           v-model="main.activeOption.theme.colCell.cell.backgroundColor"></el-color-picker>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="100" label="列竖边">
          <el-input-number v-model="main.activeOption.theme.colCell.cell.verticalBorderWidth" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="100" label="列横边">
          <el-input-number v-model="main.activeOption.theme.colCell.cell.horizontalBorderWidth" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="100" label="隐藏分割线">
          <el-switch v-model="main.activeOption.theme.colCell.cell.shadow" size="small"></el-switch>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="对齐方式">
          <el-radio-group v-model="main.activeOption.theme.colCell.text.textAlign" size="small">
            <el-radio-button label="left">左对齐</el-radio-button>
            <el-radio-button label="right">右对齐</el-radio-button>
            <el-radio-button label="center">居中对齐</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item title="角头样式" name="2393">
        <el-form-item labelAlign="left" labelWidth="100" label="角头竖边">
          <el-input-number v-model="main.activeOption.theme.cornerCell.cell.verticalBorderWidth" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="100" label="角头横边">
          <el-input-number v-model="main.activeOption.theme.cornerCell.cell.horizontalBorderWidth" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="字体大小">
          <el-input-number v-model="main.activeOption.theme.cornerCell.text.fontSize" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="字体颜色">
          <el-color-picker :predefine="predefineColors"
                           v-model="main.activeOption.theme.cornerCell.text.fill"></el-color-picker>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="背景色">
          <el-color-picker :predefine="predefineColors"
                           v-model="main.activeOption.theme.cornerCell.cell.backgroundColor"></el-color-picker>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="对齐方式">
          <el-radio-group v-model="main.activeOption.theme.cornerCell.text.textAlign" size="small">
            <el-radio-button label="left">左对齐</el-radio-button>
            <el-radio-button label="right">右对齐</el-radio-button>
            <el-radio-button label="center">居中对齐</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item title="单元格样式" name="253">
        <el-form-item label="点击事件">
          <el-input v-model="main.activeOption.config.style.cellCfg.clickHandler">
            <template #suffix>
              <el-button @click="openCode" size="small" :icon="Edit"></el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="单元格宽">
          <el-input-number v-model="main.activeOption.config.style.cellCfg.width" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="单元格高">
          <el-input-number v-model="main.activeOption.config.style.cellCfg.height" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="字体大小">
          <el-input-number v-model="main.activeOption.theme.dataCell.text.fontSize" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="字体颜色">
          <el-color-picker :predefine="predefineColors"
                           v-model="main.activeOption.theme.dataCell.text.fill"></el-color-picker>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="背景色">
          <el-color-picker :predefine="predefineColors"
                           v-model="main.activeOption.theme.dataCell.cell.backgroundColor"></el-color-picker>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="100" tip="奇数单元格背景色" label="奇数背景色">
          <el-color-picker :predefine="predefineColors"
                           v-model="main.activeOption.theme.dataCell.cell.crossBackgroundColor"></el-color-picker>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="100" label="单元格竖边">
          <el-input-number v-model="main.activeOption.theme.dataCell.cell.verticalBorderWidth" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="100" label="单元格横边">
          <el-input-number v-model="main.activeOption.theme.dataCell.cell.horizontalBorderWidth" size="small"/>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="对齐方式">
          <el-radio-group v-model="main.activeOption.theme.dataCell.text.textAlign" size="small">
            <el-radio-button label="left">左对齐</el-radio-button>
            <el-radio-button label="right">右对齐</el-radio-button>
            <el-radio-button label="center">居中对齐</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item title="自适应高度" name="254">
        <el-form-item labelAlign="left" labelWidth="90" label="开启">
          <el-switch v-model="main.activeOption.autoHeight" size="small"></el-switch>
        </el-form-item>
        <el-form-item labelAlign="left" labelWidth="90" label="最大行数">
          <el-input-number v-model="main.activeOption.autoLineNumber" min="1" size="small"/>
        </el-form-item>
      </el-collapse-item>
    </el-collapse>
    <codeedit
        @submit="closeCode"
        v-if="code.box"
        :title="code.title"
        :type="code.type"
        v-model="code.obj"
        v-model:visible="code.box"
    ></codeedit>
  </div>
</template>
<script>
import {predefineColors, SPREAD_SHEET_TYPE} from "@/option/common/dict.js";
import {Edit} from "@element-plus/icons-vue";
import codeedit from "@/page/group/code.vue";

export default {
  name: "sheet",
  components: {codeedit, Edit},
  inject: ["main"],
  data() {
    return {
      predefineColors: predefineColors,
      SPREAD_SHEET_TYPE: SPREAD_SHEET_TYPE,
      code: {
        title: "点击事件",
        box: false,
        type: "resHandler",
        obj: "",
      }
    };
  },
  methods: {
    closeCode(v) {
      this.main.activeOption.config.style.cellCfg.clickHandler = v
    },
    openCode() {
      this.code.obj = this.main.activeOption.config.style.cellCfg.clickHandler
      this.code.type = 'clickHandler'
      this.code.title = '点击事件'
      this.code.box = true;
    },
  },
  created() {
    if (!this.main.activeOption.totals) {
      this.main.activeOption.totals = {
        row: {
          showGrandTotals: false,
        },
        col: {
          showGrandTotals: false,
        }
      }
    }
  }
};
</script>


<style>
</style>